<app-modal>
  <app-modal-header [title]="headerText" (closed)="onClose()">
  </app-modal-header>
  <app-modal-body>
    <ng-container *ngIf="useOptions">
      <div class="row col-row-space custom-gutters section-padding">
        <div class="radio-buttons d-flex">
          <app-radio-button [checked]="selectedOption === Options.existingUser" [text]="T.settings.employees_departments_org.choose_existing_user | translate" (checkedChanged)="updateOption(Options.existingUser)" class="me-4"></app-radio-button>
          <app-radio-button [checked]="selectedOption === Options.newUser" [text]="T.settings.employees_departments_org.add_new_user | translate" (checkedChanged)="updateOption(Options.newUser)"></app-radio-button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="selectedOption === Options.newUser">
      <div class="row col-row-space custom-gutters section-padding" [formGroup]="form">
        <div class="col-12">
          <app-text-field
            id="firstName"
            [formGroup]="form"
            formControlName="firstName"
            [allowSpecialCharacters]="false"
            [placeholder]="(T.common.first_name | translate) + '*'"
            [maxLength]="80"
            [useReactiveMessages]="true">
          </app-text-field>
        </div>
        <div class="col-12">
          <app-text-field
            id="lastName"
            [formGroup]="form"
            formControlName="surname"
            [allowSpecialCharacters]="false"
            [placeholder]="(T.common.last_name | translate) + '*'"
            [maxLength]="80"
            [useReactiveMessages]="true">
          </app-text-field>
        </div>
        <div class="col-12">
          <app-text-field
            id="email"
            [formGroup]="form"
            formControlName="username"
            [allowSpecialCharacters]="false"
            [placeholder]="(T.settings.my_preferences.profile.email_address | translate) + '*'"
            [maxLength]="200"
            [useReactiveMessages]="true"
            [type]="'email'">
          </app-text-field>
        </div>
      </div>
      <div class="modal-info">
        <div class="modal-info-text">
          {{ T.settings.employees_departments_org.assigned_external_users_privileges | translate }}
          {{ T.settings.employees_departments_org.to_give_full_access_promote_to_employee | translate }}
        </div>
        @if (editMode) {
          <div class="mt-3">
            <app-button-rectangle
              buttonTheme="white"
              size="medium"
              [fitToContainer]="true"
              [text]="(T.settings.employees_departments_org.promote_to_employee | translate)"
              (clicked)="promoteToEmployee()">
            </app-button-rectangle>
          </div>
        }
      </div>
    </ng-container>
    <ng-container *ngIf="selectedOption === Options.existingUser">
      <div class="row col-row-space custom-gutters section-padding">
        <app-filter-dropdown-new
          [filterByModuleObjectType]="false"
          [filterType]="filterTypes.External_User"
          [appliedFilters]="filters"
          [typeahead]="true"
          [singleSelect]="true"
          [label]="(T.settings.employees_departments_org.external_user | translate)"
          (onFilterUpdate)="handleFilterChange($event)">
        </app-filter-dropdown-new>
      </div>
    </ng-container>
  </app-modal-body>
  <app-modal-footer>
    <div class="employee-manager-footer">
      <div class="footer-left-buttons d-none d-md-block">
        <ng-container *ngIf="selectedOption === Options.newUser">
          <app-button-rectangle
            *ngIf="editMode"
            size="small"
            buttonTheme="danger"
            [text]="T.common.delete | translate"
            (clicked)="deleteClicked()">
          </app-button-rectangle>
        </ng-container>
      </div>
      <div class="footer-right-buttons d-flex">
        <app-button-rectangle
          class="d-none d-md-block"
          style="margin-right: 16px"
          size="small"
          buttonTheme="white"
          (clicked)="onClose()"
          [text]="T.common.cancel | translate">
        </app-button-rectangle>
        <ng-container *ngIf="selectedOption === Options.newUser">
          <app-button-rectangle
            [disabled]="!form.valid"
            size="small"
            [text]="saveButtonText"
            [loading]="saveButtonLoader"
            (clicked)="saveNewUserClicked()">
          </app-button-rectangle>
        </ng-container>
        <ng-container *ngIf="selectedOption === Options.existingUser">
          <app-button-rectangle
            size="small"
            [text]="saveButtonText"
            [loading]="saveButtonLoader"
            (clicked)="saveExistingUserClicked()">
          </app-button-rectangle>
        </ng-container>
      </div>
    </div>
  </app-modal-footer>
</app-modal>
